import * as React from 'react';

import { FormParserContext } from 'src/contexts/form.context';
import { Accent1Switch } from 'src/components/Switch';

export function Switch() {
  const { value, onChange, script, isDisabled } = React.useContext(FormParserContext);

  function handleClick() {
    onChange(!value);
  }

  return <Accent1Switch label={script.placeholder} onClick={handleClick} isChecked={value} isDisabled={isDisabled} />;
}
